interface ErrorResponse {
    code: number;
    message: string;
}

export interface QuicktipsState {
    quicktipsData: any;
    loading: boolean;
    error: ErrorResponse | null;
}


export enum QuicktipsActionTypes {
    FETCH_QUICKTIPS_DATA = "FETCH_QUICKTIPS_DATA",
    FETCH_QUICKTIPS_DATA_SUCCESS = "FETCH_QUICKTIPS_DATA_SUCCESS",
    FETCH_QUICKTIPS_DATA_ERROR = "FETCH_QUICKTIPS_DATA_ERROR",
}

export type QuicktipsAction =
    | { type: QuicktipsActionTypes.FETCH_QUICKTIPS_DATA }
    | { type: QuicktipsActionTypes.FETCH_QUICKTIPS_DATA_SUCCESS; payload: any[] }
    | { type: QuicktipsActionTypes.FETCH_QUICKTIPS_DATA_ERROR; payload: any };